export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              关于夜猫
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                夜猫影院诞生于2020年，由一群热爱追剧的夜猫子创建。我们的初心很简单：让每一个深夜追剧的人，都能找到自己想看的好剧，并且看得痛快、看得过瘾。
              </p>
              <p>
                经过数年发展，夜猫影院已经成为国内领先的免费在线追剧平台之一，收录超过2000部电视剧资源，涵盖国产剧、韩剧、美剧、日剧、动漫、综艺等多个品类。我们坚持<strong className="text-foreground-900">全集免费、高清画质、无广告干扰</strong>三大原则，让追剧回归纯粹的快乐。
              </p>
              <p>
                夜猫影院的核心团队分布在北京、上海和首尔，24小时轮班更新内容，确保最新剧集第一时间上线。我们的字幕团队与多家海外电视台保持合作，为用户提供原汁原味的观剧体验。
              </p>
              <p>
                未来，夜猫影院将继续扩充内容库，优化播放体验，并推出更多个性化推荐功能。让我们一起，把每一个不眠之夜，都变成一场精彩的观剧之旅。
              </p>
            </div>
            <div className="flex flex-wrap gap-6 mt-6 justify-center md:justify-start">
              <div className="text-center">
                <p className="text-2xl font-bold text-primary-600">2000+</p>
                <p className="text-xs text-foreground-400">剧集资源</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-primary-600">800万+</p>
                <p className="text-xs text-foreground-400">活跃用户</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-primary-600">30+</p>
                <p className="text-xs text-foreground-400">每日更新剧集</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-primary-600">24h</p>
                <p className="text-xs text-foreground-400">全天候更新</p>
              </div>
            </div>
          </div>
          <div className="w-full max-w-xs md:max-w-sm shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20cozy%20warm%20illustration%20of%20a%20cat%20silhouette%20sitting%20next%20to%20a%20glowing%20laptop%20screen%20in%20a%20dark%20room%2C%20with%20stars%20and%20moon%20visible%20through%20a%20window%2C%20warm%20orange%20and%20amber%20ambient%20lighting%2C%20minimalist%20flat%20design%2C%20night%20owl%20aesthetic%2C%20cozy%20vibe%2C%20clean%20composition&width=600&height=600&seq=about-visual&orientation=squarish"
              alt="夜猫影院品牌形象"
              className="w-full h-auto rounded-2xl"
              width="600"
              height="600"
            />
          </div>
        </div>
      </div>
    </section>
  );
}